<template>
  <el-form :model="form" status-icon ref="loginForm" class="login-form" :style="{'margin-top': top}">
    <el-form-item prop="account">
      <el-input placeholder="请输入手机号码" v-model="form.phone" prefix-icon="el-icon-user" clearable></el-input>
    </el-form-item>
    <el-form-item prop="pass" style="margin-bottom: 0">
      <el-input placeholder="请输入你的密码" type="password" v-model="form.password" autocomplete="off" prefix-icon="el-icon-lock" clearable></el-input>
    </el-form-item>
    <el-form-item style="margin-bottom: 0">
      <div class="flex">
        <div class="flex-1 width1">
          <el-link :underline="false" type="info" @click="findPassword">找回密码</el-link>
        </div>
        <div class="flex-1 width1"></div>
      </div>
      <el-button type="primary" @click="submitForm()" class="width100" style="font-size: 16px">登录</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
  import { apiLogin } from '../../api/user'
  import { setLoginUser } from '../../util/common'

  export default {
    name: 'login',
    props: {
      top: {
        type: String,
        default() {
          return '100px'
        }
      }
    },
    data () {
      return {
        form: {
          phone: '',
          password: ''
        }
      }
    },
    methods: {
      submitForm() {
        this.$refs['loginForm'].validate((valid) => {
          if (valid) {
            apiLogin(this.form.phone, this.form.password).then(({module}) => {
              if (module != null) {
                setLoginUser(module)
                window.location.href = window.location.pathname
              }
            }).catch((errorCode) => {
              if (errorCode.code === 'login_0003') {
                this.$alert('账号错误', '错误', { confirmButtonText: '好的' })
              } else if (errorCode.code === 'login_0005') {
                this.$alert('密码错误', '错误', { confirmButtonText: '好的' })
              } else {
                this.$alert(errorCode.message, '错误', { confirmButtonText: '好的' })
              }
            })
          }
        })
      },
      resetForm() {
        this.$refs['loginForm'].resetFields()
      },
      findPassword() {
        this.$router.push({
          path: '/reset-password'
        })
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

  .login-form {
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 0;
    width: 250px;
  }

  >>> input {
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/view/login/login.vue